import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { TestDriveInfoTable } from './DisplayTestDriveInfo';

function ProspectsModal(props){
  const {
    prospects,
    buttonClassName,
    color
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const basicTitle = 'Prospects';
  const numProspects = prospects.length;
  const linkText = (numProspects>0) ? basicTitle+' ('+numProspects+')' : basicTitle;
  
  //use animation={false} with Modal to avoid findDOMNode deprecation warning (but that will turn off the pretty transition)
  return(
  <>
    <Button className={buttonClassName} color={color || "link"} onClick={toggleModal}>{linkText}</Button>
    <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>{basicTitle}</ModalHeader>
      <ModalBody>
        {numProspects>0
          ? <TestDriveInfoTable testDrives={prospects} />
          : <><p>There aren't any Prospects yet.</p>
            <p>When you complete a Test-drive, that Access Method Setup will be added to Prospects.</p>
            </>
        }
      </ModalBody>
    </Modal>
  </>
  );
}

export default ProspectsModal;